<template>
  <div class="pageCon" id="pageCon__14">
    <div class="header">
      <div class="leftText">
        <img src="../assets/list.png" style="width:30px;height:30px;margin-right:10px;"/>
        <div class="headerText">诊疗记录</div>
      </div>
      <img src="../assets/close.png" style="width:30px;height:30px;cursor:pointer" @click="closeSelf"/>
    </div>
    <div class="scrollCon">
      <div class="timeline-row" v-for="(item, index) in diagnoseList" :key="index">
        <div class="timeline-side" :class="{'timeline-break': isActiveItem(item)}">
          <div class="timeline-dot-row">
            <div class="timeline-dot" :class="'dot-' + item.diagnosisType"></div>
            <div class="timeline-date">{{ item.timelineDate }}</div>
          </div>
          <div class="timeline-type-text" :class="'type-' + item.diagnosisType">{{ item.diagnosisType }}</div>
          <div v-if="isActiveItem(item)" class="timeline-active-badge">当前活动</div>
          <div class="timeline-line" v-if="index < diagnoseList.length - 1 && !isActiveItem(item)"></div>
        </div>
        <div class="diagnoseItemCon">
        <div class="diagnoseHeader" style="height: 72px;background-color: rgb(165, 191, 108);padding-top: 10px"
             v-if="item.diagnosisType === '手术'">
          <div class="baseInfoCon">
            <div style="flex: 1;display: flex;">
              <div style="display:flex;width: 200px;padding-right: 20px">
                <div style="margin-right: 2px">手术日期:</div>
                <div>{{item.operation_date | formatDate1}}</div>
              </div>
              <div style="display:flex;width: 200px;padding-right: 20px">
                <div style="margin-right: 2px">状态:</div>
                <div>{{item.operation_status}}</div>
              </div>
              <div style="display:flex;min-width: 200px;padding-right: 20px">
                <div style="margin-right: 2px">手术部位:</div>
                <div>{{item.operation_position}}</div>
              </div>
              <div style="display:flex;">
                <div style="margin-right: 2px">手术名称:</div>
                <div>{{item.operation_name}}</div>
              </div>
            </div>
            <div class="btns">
              <!--<img src="../assets/love.png" style="width: 20px;height:20px;" v-if="true" class="btn"
                   @click="collect()"/>-->
              <!--<img src="../assets/love_fill.png" style="width: 20px;height:20px;" v-if="item.tagged" class="btn"
                   @click="collect(item.id,item.tagged,item)"/>-->
            </div>
          </div>
          <div class="diagnoseInfo-box">与
            <div class="diagnose-suggest">
              <div style="margin-top: 14px;display: flex">
                <div style="display:flex;width: 200px;padding-right: 20px">
                  <div style="margin-right: 2px">签字医生:</div>
                  <div>{{item.sign_doctor}}</div>
                </div>
                <div style="display:flex;width: 200px;padding-right: 20px;">
                  <div style="margin-right: 2px">手术医生:</div>
                  <div>{{item.operation_doctor}}</div>
                </div>
                <div style="display:flex;width: 200px;padding-right: 20px;">
                  <div style="margin-right: 2px">助理医师1:</div>
                  <div>{{item.assistant1}}</div>
                </div>
                <div style="display:flex;width: 200px;padding-right: 20px;">
                  <div style="margin-right: 2px">助理医师2:</div>
                  <div>{{item.assistant2}}</div>
                </div>
                <div style="display:flex;width: 200px;padding-right: 20px;">
                  <div style="margin-right: 2px">手术费用:</div>
                  <div>{{item.operation_fee / 100}}</div>
                </div>
              </div>
            </div>
            <div class="modify-diagnose">
            </div>
          </div>
        </div>
        <div class="diagnoseHeader" style="height: 72px;background-color: rgb(146,82,17)" v-if="item.diagnosisType === '住院'">
          <div class="baseInfoCon">
            <div class="baseInfoCon-1">
              <div class="con">住院号:  <span>{{item.medical_record_num}}</span></div>
              <div class="con">入院时间:  <span>{{item.inpat_date | formatDate}}</span></div>
              <div class="con">出院时间:  <span>{{item.outpat_date | formatDate}}</span></div>
            </div>
            <!--<div class="btns">
              <img src="../assets/love.png" style="width: 20px;height:20px;" v-if="false" class="btn"
                   @click="collect()"/>
              <img src="../assets/love_it.png" style="width: 20px;height:20px;" v-if="true" class="btn"
                   @click="collect()"/>
            </div>-->
          </div>
          <div style="display:flex;margin-top: 18px">
            <div style="display:flex;justify-content:flex-start;width: 200px;padding-right: 20px">疗效：{{item
              .curative_effect}}</div>
            <div style="display:flex;justify-content:flex-start;">诊断：{{item
              .doctor_conclusion}}</div>
          </div>
        </div>
        <div class="checksCon1" v-if="item.diagnosisType === '住院' && item.image_hospitalization.length"
             style="background-color: rgb(255, 253, 233)">
          <div class="image-item" v-for="image in item.image_hospitalization" :key="image.id">
            <div class="image"
                 :style="`background-image: url(${hospitalization_imagesThumbnails + image.path})`"
                 @click="LookBigPhoto(image.path, image, item.id, 'hospitalized')"
            ></div>
            <div class="title">{{image.type | formatType}}</div>
          </div>
        </div>
        <div class="diagnoseHeader" v-if="item.diagnosisType === '影像'">
          <div class="baseInfoCon">
            <div style="flex: 1;display: flex;justify-content: flex-start;">
              <div style="width: 200px;padding-right: 20px;text-align: left">检查编号:  <span>{{item.id_in_hospital}}</span></div>
              <div style="text-align: left">申请医生:  <span>{{item.applicant}}</span></div>
            </div>
            <div class="btns">
              <div class="btn" style="width:80px" @click="printReport($event,item,index,true)"><i class="iconfont icon-iconset0339"></i>下载</div>
              <div class="btn" style="width:80px" @click="printReport($event,item,index,false)"><i class="iconfont icon-dayin1"></i>打印</div>

              <img src="../assets/love.png" style="width: 20px;height:20px;" v-if="!item.tagged" class="btn" @click="collect(item.id,item.tagged,item)"/>
              <img src="../assets/love_it.png" style="width: 20px;height:20px;" v-if="item.tagged" class="btn" @click="collect(item.id,item.tagged,item)"/>
            </div>
          </div>
          <div style="flex: 1;display: flex;justify-content: flex-start; margin:4px 0px;">
            <span style="width: 200px;padding-right: 20px;text-align: left">影像诊断:{{item.doctor_conclusion}}</span>
            <span style="width: 200px;padding-right: 20px;text-align: left">建议：{{item.doctor_suggestion}}</span>
          </div>

          <div class="baseInfoCon"  style="margin-top:16px;" v-if="hasMedicalRecord(item)">
            <div style="flex: 1;display: flex;justify-content: flex-start;">
              <div style="width: 200px;padding-right: 20px;text-align: left">病历信息：</div>
            </div>
            <div class="btns">
              <div class="btn" style="width:120px" v-if="$route.path === '/home/intell'"  @click.stop="importMedicalRecord(item)"><i class="iconfont icon-iconset0339"></i>导入当前工作区</div>
            </div>
          </div>

          <!-- 病历信息 -->
          <div class="medical-record-section" v-if="hasMedicalRecord(item)">
            <div class="medical-record-content">
              <div class="mr-field" v-if="item.complaint"><span class="mr-label">主诉：</span>{{item.complaint}}</div>
              <div class="mr-field" v-if="item.initial_conclusion"><span class="mr-label">门诊诊断：</span>{{item.initial_conclusion}}</div>
              <div class="mr-field" v-if="item.disease_history_present"><span class="mr-label">现病史：</span>{{item.disease_history_present}}</div>
              <div class="mr-field" v-if="item.disease_history_before"><span class="mr-label">既往史：</span>{{item.disease_history_before}}</div>
              <div class="mr-field" v-if="item.physical_examination"><span class="mr-label">体格检查：</span>{{item.physical_examination}}</div>
              <div class="mr-field" v-if="item.allergy_history"><span class="mr-label">过敏史：</span>{{item.allergy_history}}</div>
              <div class="mr-field" v-if="item.disease_history_family"><span class="mr-label">家族史：</span>{{item.disease_history_family}}</div>
            </div>
            <!-- <div class="medical-record-btn" v-if="$route.path === '/home/intell'">
              <div class="btn" @click.stop="importMedicalRecord(item)">将病历信息导入当前工作区</div>
            </div> -->
          </div>
          <!-- <div>
            <span>建议：{{item.doctor_suggestion}}</span>
          </div> -->
        </div>
        <div class="checksCon" v-if="item.diagnosisType === '影像'">
          <div class="checkTypeCon" v-for="(value, key, index) in item.imagesByType" :key="index">
            <div class="checkHeader">
              <div class="leftCheck">
                <template v-if="(key === 's') && value.length > 0">
                  <div>检查类型：<span>皮肤镜</span></div>
                  <div style="max-width: 500px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">镜下所见：<span class="span-text">{{item.dermoscopy_report_text}}</span></div>
                </template>
                <template v-if="key === '1'  && value.length > 0">
                  <div>检查类型：<span>大体图/伍德灯</span></div>
                  <div style="max-width: 500px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">镜下所见：<span class="span-text">{{item.macro_report_text}}</span></div>
                </template>
                <template v-if="key === '8'  && value.length > 0">
                  <div>检查类型：<span>CT</span></div>
                  <div style="max-width: 500px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">镜下所见：<span class="span-text">{{item.ct_report_text}}</span></div>
                </template>
                <template v-if="key === '16'  && value.length > 0">
                  <div>检查类型：<span>B超</span></div>
                  <div style="max-width: 500px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">镜下所见：<span class="span-text">{{item.b_ultrasonic_report_text}}</span></div>
                </template>
                <template v-if="key === '32'  && value.length > 0">
                  <div>检查类型：<span>病理</span></div>
                  <div style="max-width: 500px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">镜下所见：<span class="span-text">{{item.pathology_report_text}}</span></div>
                </template>
              </div>
              <div class="rightbtn">
                <div class="btn_color" v-if="key === 's' && value.length > 0" @click="intellSearchResult(value,item.id)">{{differentContent.titleCon}}</div>
              </div>
            </div>
            <div class="imgsCon">
              <div class="imgBackCon" v-for="(Item, imgIndex) in value" :key="imgIndex"
                   @mouseover="overImg(Item.id,Item.type,value,imgIndex)" @mouseleave="hideOverImg()"  @click="LookBigPhoto(Item.path, Item, id)">
                <div class="img-box">
                  <img
                         :src="imageSrcPrefixThumbnails + Item.path"
                         @load="imgOnload"
                        />
                </div>
                <div class="diseasePosition">
                  {{Item.position_detail}}
                  <span
                    v-if="key === '1'"
                    class="wd-btn"
                    :class="{'wd-btn-active': Item.origin === 'WOOD'}"
                    title="标记/取消伍德灯"
                  >WD</span>
                </div>
                <div class="diseasePosition diseasePosition2"><span v-if="Item.print_time!==-30610253143000" style="font-size:12px;">打印：{{moments(Item.print_time)}}</span></div>
                <div class="loveImg" v-if="hoverIndexOnImg === imgIndex && hoverDiagnoseType === Item.type &&
                hoverDiagnoseId === Item.id" @click.stop="collectImg(Item.id, Item)">
                  <img src="../assets/love.png" style="width:15px;height:15px;" v-show="Item.tagged === 0"/>
                  <img src="../assets/love_fill.png" style="width:15px;height:15px;"
                       v-show="Item.tagged === 1"/>
                </div>
                <!--<div class="largeImg" v-if="hoverIndexOnImg === imgIndex && hoverDiagnoseType === Item.type &&
                hoverDiagnoseId === Item.id">
                  <img src="../assets/large.png" style="width:15px;height:15px;"/>
                </div>-->
              </div>
            </div>
          </div>
        </div>
        <div class="diagnoseHeader" style="background-color: rgb(146, 27, 81)" v-if="item.diagnosisType
          === '美容'">
          <div class="cosmetology-list-wrap">
            <div class="cosmetology-row" v-for="(detail, idx) in item.treat_details" :key="idx">
              <div class="cr-item cr-num">{{detail.detail_title}}</div>
              <div class="cr-item"><span class="label">美容/治疗项目：</span>{{detail.item_info ? detail.item_info.item_name : ''}}</div>
              <div class="cr-item"><span class="label">治疗设备/方法：</span>{{detail.device_info ? detail.device_info.device_name : ''}}</div>
              <div class="cr-item"><span class="label">治疗模块/药物：</span>{{detail.module_info ? detail.module_info.module_name : ''}}</div>
              <div class="cr-item"><span class="label">参数：</span>{{getParamStr(detail.param_value)}}</div>
            </div>
            <!--<div class="right">
              <div class="modify-btn" @click="continueTreat(item)" v-if="true">
                <div>继续治疗</div>
              </div>
              <div class="modify-btn disabled" v-if="false">
                <div>继续治疗</div>
              </div>
              <div class="modify-btn" v-if="isShowModifyDiagnosisBtn(item.create_time)"
                   @click="modifyCosmetology(item)">
                <div class="iconfont modify-btn-icon" >&#xe61d;</div>
                <div>编辑</div>
              </div>
              <div class="modify-btn disabled" v-if="!isShowModifyDiagnosisBtn(item.create_time)">
                <div class="iconfont modify-btn-icon">&#xe61d;</div>
                <div>编辑</div>
              </div>
            </div>-->
          </div>
        </div>
        <div class="checksCon1" v-if="item.diagnosisType === '美容' && item.image_cosmetology.length"
             style="background-color: #fed8d8">
          <div class="image-item" v-for="image in item.image_cosmetology" :key="image.id">
            <!--showPic(image.path)-->
            <div
              :style="`background-image: url('${cosmetology_imagesThumbnails}${image.path}')`"
              class="image"
              @click="LookBigPhoto(image.path, image, item.patient_id, 'hairdressing')"
            >
            </div>
            <div class="title" style="display: flex;justify-content: space-between">
              <div>{{image.status}}</div>
              <div>{{image.created_time | formatDate2}}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="showLargeImage"
        center
        custom-class="similarDialog showBigImage_dialog"
        :modal="false"
        top="0"
        :fullscreen="true"
        :before-close="closeShowLargeImage"
        v-if="showLargeImage"
      >
      <div style="position: absolute;left: 20px;right: 20px;top: 45px;bottom:20px;display: flex;align-items: center">
      <CompareImage
        :primevalImage="primevalImage"
        :compareImageList="compareImageList"
        :isCompareImage="isCompareImage"
        :largeImgage="largeImgage"
        :largeImgage2="largeImgage2"
        :imageCompileClass="imageCompileClass"
        :imageCompileClass2="imageCompileClass2"
        :selected="selected"
        :selected2="selected2"
        :activeImage="activeImage"
        :activeImage2="activeImage2"
        @imageClick="imageClick"
        @imageDblclick="imageDblclick"
        @imageOnload="imageOnload"
        @checkImageCompile="checkImageCompile"
      ></CompareImage>
      </div>
      </el-dialog>
    <el-dialog
      :visible.sync="showLargeImage1"
      center
      custom-class="similarDialog showBigImage_dialog_1"
      :modal="false"
      top="0"
      :fullscreen="true"
    >
      <div class="bigImage">
        <Lookimage :largeImgage="largeImage"></Lookimage>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import diagnosisById from '../gql/diagnosisById.gql'
import enterIntell from '../gql/enterIntell.gql'
import DetailedResults from './DetailedResults.vue'
import Util from '../utils/utils.js'
import api from '../api';
import moment from 'moment';
import _ from 'lodash';
import {lookPhoto} from "../utils/lookPhoto.js";
import CompareImage from './CompareImage';
import axios from 'axios';
import Lookimage from './LookBigImage.vue';
const differentContent = {};
if (process.env.VUE_APP_SHOW_INTEL === 'yes') {
  // differentContent.titleCon = '智能搜图详细结果';
  differentContent.titleCon = '搜图详细结果';
} else {
  differentContent.titleCon = '搜图详细结果';
}
let template = {};
const initialTime = -30610253143000;
export default {
  props: ['allDiagnoses', 'activeId', 'wordBook', 'id', 'selectedDiagnosisType']
    /*{
    // 诊断对象的列表
    // diagnoseList: []
    allDiagnoses: Array,
    // 当前选择的id
    activeId: Number,
    // 显示诊断信息详情所需要的百科
    wordBook: Object,
    id: String,
  }*/,
  data() {
    return {
      differentContent,
      hospitalization_images: api.hospitalization_images,
      hospitalization_imagesThumbnails: api.hospitalization_imagesThumbnails,
      imageSrcPrefix: api.imageSrcPrefix,
      imageSrcPrefixThumbnails: api.imageSrcPrefixThumbnails,
      cosmetology_images: api.cosmetology_images,
      cosmetology_imagesThumbnails: api.cosmetology_imagesThumbnails,
      diagnoseList: [],
      // 当前鼠标悬停的图片位置索引
      hoverIndexOnImg: 0,
      // 鼠标悬停到那个位置的时候诊断的类型
      hoverDiagnoseType: '',
      // 当前所悬停的诊断id
      hoverDiagnoseId: 0,
      // 显示智能诊断详细结果
      showDiagnoseRes: false,
      detailResult: [],
      imgListRes: [],
      largeImgage: "",
      showLargeImage: false,
      isDownLoad:false,
      showLargeImage1: false,
      // 住院查看大图地址
      largeImage: '',
    }
  },
  mixins: [lookPhoto],
  filters: {
    formatDate(time) {
      if (time === initialTime) {
        return '';
      } else {
        return moment(time).format("YYYY-MM-DD HH:mm");
      }
    },
    formatDate1(time) {
      if (time === initialTime) {
        return '';
      } else {
        return moment(time).format("YYYY-MM-DD");
      }
    },
    formatDate2(time) {
      if (time === initialTime) {
        return '';
      } else {
        return moment(time).format("YYMMDD HH:mm");
      }
    },
    formatType(type) {
      if (type === 1) {
        return '入院照片'
      } else if (type === 2) {
        return '出院照片'
      }
    },
  },
  async created() {
    await this.queryMyTemplate();
    let ids = [];
    
    console.log(this.selectedDiagnosisType)
    if (this.selectedDiagnosisType === '影像'){
      ids.push(this.activeId);
    }
    console.log(ids)
   /* console.log(this.activeId,'isac')
    console.log(this.allDiagnoses)*/
    for(let i = 0; i < this.allDiagnoses.length; i++) {
      console.log(this.allDiagnoses[i])
      let idItem = this.allDiagnoses[i].id;
      if(idItem !== this.activeId) {
        ids.push(idItem);
      }
    }
    // 请求诊断详情信息
    for(let j = 0; j < ids.length; j++) {
    
      let diagnosisDetailRes = await this.$apollo.query({
        query: gql`query ($id: Int!){
            diagnosis(id: $id) {
                id,
                doctor {
                    id
                },
                previewImage {
                    id
                },
                applicant,
                applicant_unit,
                review_doctor,
                complaint,
                id_in_hospital,
                time,
                disease_history_present,
                disease_history_before,
                physical_examination,
                allergy_history,
                disease_history_family,
                images {
                    id,
                    path,
                    tagged,
                    server,
                    type,
                    origin,
                    position_detail,
                    position_overview,
                    print_time
                    diagnosis{
                        id
                        time
                    }
                },
                image_type_flag,
                doctor_suggestion,
                doctor_conclusion,
                doctor_report,
                macro_report_text,
                macro_report_images,
                b_ultrasonic_report_text,
                b_ultrasonic_report_images,
                ct_report_text,
                ct_report_images,
                dermoscopy_report_text,
                dermoscopy_report_images,
                pathology_report_text,
                pathology_report_images,
                top1,
                top2,
                top3,
                unit,
                initial_conclusion,
                disease_history_present,
                disease_history_before,
                physical_examination,
                allergy_history,
                disease_history_family,
                lab,
                tagged,
                position_overview_list,
                position_detail_list,
                patient{
                        id
                        id_in_hospital
                        name
              gender
              race
              skin_color
              birthday
              age
              phone
              address
              id_card_number
              native_place
              created_time
              country
              profession
              email
            }
            }
        }`,
        variables: {
          id: ids[j]
        },
        fetchPolicy: "no-cache"
      });
      if (diagnosisDetailRes.data.diagnosis!=null){
        this.diagnoseList.push(diagnosisDetailRes.data.diagnosis);
      }
      
    }
    for(let k = 0; k < this.diagnoseList.length; k++) {
      this.diagnoseList[k].imagesByType = {
        s: [],
        1: [],
        8: [],
        16: [],
        32: []
      };
      this.diagnoseList[k].doctor_conclusion = this.filterConclusion(this.diagnoseList[k].doctor_conclusion);
      this.diagnoseList[k].time1 = this.diagnoseList[k].time;
      this.diagnoseList[k].diagnosisType = '影像';
      this.diagnoseList[k].time = moment(this.diagnoseList[k].time).format("YYYY-MM-DD HH:mm");
      this.diagnoseList[k].timelineDate = moment(this.diagnoseList[k].time1).format("YYYY-MM-DD");
      for(let i = 0;i < this.diagnoseList[k].images.length; i++) {

        let self = this;
        await new Promise((resolve,reject) => {
            let img = new Image();
            img.src = api.imageSrcPrefixThumbnails + self.diagnoseList[k].images[i].path;
            img.onload = () => {
              let width = img.width;
              let height = img.height;
              if(width / height < 130 / 100) {
                //
                img.height = 100;
                img.width = width * 100 / height;
              } else {
                img.width = 130;
                img.height = height * 130 / width;
              }
              self.diagnoseList[k].images[i].width = img.width;
              self.diagnoseList[k].images[i].height = img.height;
              resolve();
            }
        })
        switch(this.diagnoseList[k].images[i].type) {
          case Util.SOAK.code:
            self.diagnoseList[k].imagesByType.s.push(self.diagnoseList[k].images[i]);
            break;
          case Util.POLARRIZE.code:
            self.diagnoseList[k].imagesByType.s.push(self.diagnoseList[k].images[i]);
            break;
          case Util.GENERAL.code:
            self.diagnoseList[k].imagesByType['1'].push(self.diagnoseList[k].images[i]);
            break;
          case Util.CT.code:
            self.diagnoseList[k].imagesByType['8'].push(self.diagnoseList[k].images[i]);
            break;
          case Util.BC.code:
            self.diagnoseList[k].imagesByType['16'].push(self.diagnoseList[k].images[i]);
            break;
          case Util.PATHOlOGY.code:
            self.diagnoseList[k].imagesByType['32'].push(self.diagnoseList[k].images[i]);
            break;
        }
        self.diagnoseList[k].imagesByType.s = _.unionBy(self.diagnoseList[k].imagesByType.s,'id','type','path');
        self.diagnoseList[k].imagesByType['1'] = _.unionBy(self.diagnoseList[k].imagesByType['1'],'id','type','path');
        self.diagnoseList[k].imagesByType['8'] = _.unionBy(self.diagnoseList[k].imagesByType['8'],'id','type','path');
        self.diagnoseList[k].imagesByType['16'] = _.unionBy(self.diagnoseList[k].imagesByType['16'],'id','type','path');
        self.diagnoseList[k].imagesByType['32'] = _.unionBy(self.diagnoseList[k].imagesByType['32'],'id','type','path');
      }
    }
    this.$set(this.diagnoseList);
    // 查询住院信息
    const response = await this.$apollo.query({
      query: gql`query patient($id: Int!) {
        patient(id: $id) {
          id
          hospitalization{
            id
            medical_record_num
            inpat_date
            outpat_date
            curative_effect
            update_time
            diagnosis
            image_hospitalization{
              id
              path
              type
            }
          }
          operation{
            id
            create_time
            update_time
            operation_name
            operation_position
            operation_date
            sign_doctor
            operation_doctor
            assistant1
            assistant2
            operation_fee
            operation_status
            relevant_info{
                id
            }
          }
          cosmetology{
            id
            patient_id
            treat_no
            diagnosis
            main_suit
            past_history
            operate_doctor
            register_doctor
            fee
            remarks
            create_time
            update_time
            image_cosmetology{
              id
              path
              status
              created_time
            }
            treat_details{
              id
              detail_title
              item_info{
                id
                item_name
              }
              device_info{
                id
                device_name
              }
              module_info{
                id
                module_name
              }
              param_value
              total_times
              left_times
            }
          }
        }
      }`,
      variables: {
        id: this.id,
      },
      fetchPolicy: "no-cache"
    });
    const tableData2 = response.data.patient.hospitalization;
    const tableData3 = response.data.patient.operation;
    const tableData4 = response.data.patient.cosmetology;
    for (const item of tableData2) {
      item.diagnosisType = '住院';
      item.time1 = item.update_time;
      item.timelineDate = moment(item.time1).format("YYYY-MM-DD");
      item.doctor_conclusion = this.filterConclusion(item.diagnosis);
    }
    for (const item of tableData3) {
      item.diagnosisType = '手术';
      item.time1 = item.update_time;
      item.timelineDate = moment(item.time1).format("YYYY-MM-DD");
    }
    for (const item of tableData4) {
      item.diagnosisType = '美容';
      item.time1 = item.update_time;
      item.timelineDate = moment(item.time1).format("YYYY-MM-DD");
      for (const item1 of item.treat_details) {
        item1.value = item1.detail_title;
        item1.label = item1.detail_title;
      }
      if (item.treat_details.length) {
        if (item.treat_details[0].item_info) {
          item.item_name = item.treat_details[0].item_info.item_name;
        }
        if (item.treat_details[0].device_info) {
          item.device_name = item.treat_details[0].device_info.device_name;
        }
        if (item.treat_details[0].module_info) {
          item.module_name = item.treat_details[0].module_info.module_name;
        }
        if (item.treat_details[0].param_value) {
          item.param_value = JSON.parse(item.treat_details[0].param_value);
        }
        item.showParNum = item.treat_details[0].value;
      } else {
        item.item_name = '';
        item.device_name = '';
        item.module_name = '';
        item.param_value = [];
      }
    }
    const diagnoseList = this.diagnoseList.concat(tableData2, tableData3, tableData4).sort((a, b) => b.time1 - a.time1);
    const findIndex = diagnoseList.findIndex(item => {
      return item.diagnosisType === this.selectedDiagnosisType && item.id === this.activeId;
    });
    if (findIndex > -1) {
      const firstIndexObj = diagnoseList.splice(findIndex, 1)[0];
      diagnoseList.unshift(firstIndexObj);
    }
    this.diagnoseList = diagnoseList;
   
  },
  methods: {
    isActiveItem(item) {
      return item.diagnosisType === this.selectedDiagnosisType && item.id === this.activeId;
    },
    hasMedicalRecord(item) {
      return !!(
        item.complaint || item.initial_conclusion || item.disease_history_present || item.disease_history_before ||
        item.physical_examination || item.allergy_history || item.disease_history_family
      );
    },
    importMedicalRecord(item) {
      this.$emit("message", {
        type: "importMedicalRecord",
        complaint: item.complaint,
        initial_conclusion: item.initial_conclusion,
        disease_history_present: item.disease_history_present,
        disease_history_before: item.disease_history_before,
        physical_examination: item.physical_examination,
        allergy_history: item.allergy_history,
        disease_history_family: item.disease_history_family
      });
      this.$message.success('病历信息已导入当前工作区');
    },
    async toggleWoodLamp(Item) {
      const newOrigin = Item.origin === 'WOOD' ? '' : 'WOOD';
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation($id: Int!, $origin: String) {
            modifyImage(id: $id, origin: $origin)
          }`,
          variables: { id: Item.id, origin: newOrigin }
        });
        Item.origin = newOrigin;
        this.$message.success(newOrigin === 'WOOD' ? '已标记为伍德灯图片' : '已取消伍德灯标记');
      } catch (e) {
        this.$message.error('操作失败: ' + (e.message || '未知错误'));
      }
    },
    getParamStr(param_value) {
      if (!param_value) return '';
      try {
        const parsed = JSON.parse(param_value);
        return parsed.map(p => p.value).join(';');
      } catch (e) {
        return param_value;
      }
    },
    selectedParNumChange(detail_title, item) {
      const filterArr = item.treat_details.filter((item1) => item1.detail_title === detail_title);
      if (filterArr[0].item_info) {
        item.item_name = filterArr[0].item_info.item_name;
      }
      if (filterArr[0].device_info) {
        item.device_name = filterArr[0].device_info.device_name;
      }
      if (filterArr[0].module_info) {
        item.module_name = filterArr[0].module_info.module_name;
      }
      if (filterArr[0].param_value) {
        item.param_value = JSON.parse(filterArr[0].param_value);
      }
      item.showParNum = detail_title;
    },
    imgOnload(e) {
      const tag = e.target;
      if (tag.width / tag.height >= (130 / 100)) {
        const height = tag.height;
        const width = tag.width;
        const countWidth = width / (height / 100);
        e.srcElement.style.height = '100px';
        e.srcElement.style.width = countWidth + 'px';
        const s = (countWidth - 130) / 2;
        e.srcElement.style.marginLeft = '-' + s + 'px';
      } else {
        const height = tag.height;
        const width = tag.width;
        const countHeight = height / (width / 130);
        e.srcElement.style.width = '130px';
        e.srcElement.style.height = countHeight + 'px';
        const s = (countHeight - 100) / 2;
        e.srcElement.style.marginLeft = 0;
        e.srcElement.style.marginTop = '-' + s + 'px';
      }
    },
    showPic(path) {
      this.largeImage = `${this.hospitalization_images}${path}`;
      this.showLargeImage1 = true;
    },
    filterConclusion(id) {
      let name;
      // 从自定义模板中找病种名称
      const f = (data) => {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            name = data[i].name;
            break;
          } else if (data[i].children && data[i].children.length) {
            f(data[i].children);
          }
        }
      };
      if (template.myTemplate) {
        f(template.myTemplate);
      }
      // 如果自定义中没有找到则在原始模板中查找
      if (!name) {
        if (this.wordBook[id]) {
          name = this.wordBook[id].name
        }
      }
      return name ? name : id;
    },
    // 获取医生自定义模板
    async queryMyTemplate() {
      // 请求医生自定义的模板路径
      const res = await this.$apollo.query({
        query: gql`{
          me{
            id
            template
          }
        }`,
        fetchPolicy: 'no-cache',
      });
      // 根据路径请求模板
      const path = res.data.me.template;
      // 如果没有自定义模板
      if (path === '') {
        return;
      }
      const msg =  await axios.request({
        method: 'get',
        url: api.template + path,
      });
      template = msg.data;
    },
    // 关闭该弹窗
    closeSelf() {
      this.$emit("message",{type:"close",message:'true'});
      // this.$emit("message",)
    },
    moments(date) {
      if (!!date) {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    // 收藏或者是取消收藏
    async collect(id, taggedStatus, item) {
      let self = this;
      try {
        let collectionRes = await this.$apollo.mutate({
          mutation: gql`mutation ($id: Int!,$tagged: Boolean){
            modifyDiagnosis(id: $id,tagged: $tagged)
          }`,
          variables: {
            id,
            tagged: !taggedStatus
          }
        })
        if(!taggedStatus) {
          this.$message({
            type: "success",
            message: "收藏成功"
          });
        } else {
          this.$message({
            type: "success",
            message: "取消收藏成功"
          })
        }
        // 更改该诊断的收藏标记
        item.tagged = !taggedStatus;
      } catch(e) {
        this.$message.error("收藏失败");
      }
    },
    // 打印报告
    printReport(event,item,index,isDownLoad) {
      let self = this;
      this.isDownLoad = isDownLoad;
      event.cancelBubble = false;
      this.printIndex = index;
      let allImages = item.images;
      let reportObj = {};
      reportObj.skin = {};
      reportObj.skin.imgs = this.getImagesPath(item.imagesByType.s,"皮肤镜");
      reportObj.skin.underMirror = item.dermoscopy_report_text;
      reportObj.general = {};
      reportObj.general.imgs = this.getImagesPath(item.imagesByType['1'],"大体图/伍德灯");
      reportObj.general.underMirror = item.macro_report_text;
      reportObj.ct = {};
      reportObj.ct.imgs = this.getImagesPath(item.imagesByType['8'],"CT");
      reportObj.ct.underMirror = item.ct_report_text;
      reportObj.bc = {};
      reportObj.bc.imgs = this.getImagesPath(item.imagesByType['16'],"B超");
      reportObj.bc.underMirror = item.b_ultrasonic_report_text;
      reportObj.bl = {};
      reportObj.bl.imgs = this.getImagesPath(item.imagesByType['32'],"病理");
      reportObj.bl.underMirror = item.pathology_report_text;
      reportObj.diagnoseResult = item.doctor_conclusion;
      reportObj.time = item.time;
      reportObj.otherDes = item.doctor_report;
      let diagnoseInfo = {};
      diagnoseInfo.applicant = item.applicant;
      diagnoseInfo.applicant_unit = item.applicant_unit;
      diagnoseInfo.id_in_hospital = item.id_in_hospital;
      diagnoseInfo.initial_conclusion = item.initial_conclusion;
      diagnoseInfo.lab = item.lab;
      diagnoseInfo.time = item.time;
      diagnoseInfo.unit = item.unit;
      diagnoseInfo.complaint = item.complaint;
      diagnoseInfo.disease_history_present = item.disease_history_present;
      diagnoseInfo.disease_history_before = item.disease_history_before;
      diagnoseInfo.physical_examination = item.physical_examination;
      diagnoseInfo.allergy_history = item.allergy_history;
      diagnoseInfo.disease_history_family = item.disease_history_family;
      diagnoseInfo.review_doctor = item.review_doctor;
      self.$emit("message",{type:"printreport",data:reportObj,dinfo:diagnoseInfo,isDownLoad:self.isDownLoad,advise:item.doctor_suggestion,
        form:item.patient});
    },
        getImagesPath(ImgList,type) {
      let imgIdsRes = _.cloneDeep(ImgList);
      for(let i = 0;i < imgIdsRes.length;i++) {
              imgIdsRes[i].src = api.imageSrcPrefix + imgIdsRes[i].path;
              imgIdsRes[i].type = type;
              imgIdsRes[i].position = {};
              imgIdsRes[i].position.overviewPosition = imgIdsRes[i].position_overview;
              imgIdsRes[i].position.detailPosition = imgIdsRes[i].position_detail.split("-")[1]?imgIdsRes[i].position_detail.split("-")[1]:"";
      }
      return imgIdsRes;
    },
    // 显示智能搜图详细结果
    async intellSearchResult(value, diagnoseId) {
      // 点击智能搜图详细结果时候讲上一次生成的数据清空
      this.imgListRes = [];
      this.detailResult = [];
      for(let n = 0; n < value.length; n++) {
        this.imgListRes.push(api.imageSrcPrefixThumbnails + value[n].path);
      }
      let imgsRes = await this.$apollo.query({
        query: enterIntell,
        variables: {
          id: diagnoseId
        }
      })
      let imagesList = imgsRes.data.diagnosis.images;
      for(let i = 0;i < value.length; i++) {
        let tempJson = {};
        tempJson.crop = [];
        tempJson.result = [];
        // 遍历图片数组
        for(let j = 0; j < imagesList.length; j++) {
          if(imagesList[j].id === value[i].id && imagesList[j].type === value[i].type) {
            tempJson.malignant_prob = imagesList[j].malignant_prob;
            tempJson.similar = imagesList[j].similarImages;
            let resultJson1 = {};
            resultJson1.cls_id = imagesList[j].top1;
            resultJson1.prob = imagesList[j].top1_prob;
            let resultJson2 = {};
            resultJson2.cls_id = imagesList[j].top2;
            resultJson2.prob = imagesList[j].top2_prob;
            let resultJson3 = {};
            resultJson3.cls_id = imagesList[j].top3;
            resultJson3.prob = imagesList[j].top3_prob;
            tempJson.result.push(resultJson1);
            tempJson.result.push(resultJson2);
            tempJson.result.push(resultJson3);
            for(let k = 0; k < imagesList[j].crops.length; k++) {
              let cropJson = {};
              cropJson.rect = imagesList[j].crops[k].rect;
              cropJson.result = tempJson.result;
              tempJson.crop.push(cropJson);
            }
            break;
          }
        }
        this.detailResult.push(tempJson);
      }
      this.$emit("message",{type: "showIntell",detail_result: this.detailResult,imgList: this.imgListRes});
    },
    // 当前鼠标悬停的位置
    overImg(diagnoseId,checkType,imgList,index) {
      this.hoverDiagnoseId = diagnoseId;
      this.hoverIndexOnImg = index;
      this.hoverDiagnoseType = checkType;
    },
    hideOverImg() {
      this.hoverIndexOnImg = -1;
      this.hoverDiagnoseType = '';
    },
    // 收藏该图片
    async collectImg(imgId, imgItem) {
      try {
        if (imgItem.tagged === 0) {
          let collectionRes = await this.$apollo.mutate({
            mutation: gql`mutation ($id: Int!,$tagged: Int){
            modifyImage(id: $id,tagged: $tagged)
          }`,
            variables: {
              id: imgId,
              tagged: 1
            }
          });
          this.$message({
            type: "success",
            message: "收藏成功"
          });
          imgItem.tagged = 1;
        } else if (imgItem.tagged === 1) {
          let collectionRes = await this.$apollo.mutate({
            mutation: gql`mutation ($id: Int!,$tagged: Int){
            modifyImage(id: $id,tagged: $tagged)
          }`,
            variables: {
              id: imgId,
              tagged: 0
            }
          });
          this.$message({
            type: "success",
            message: "取消收藏成功"
          });
          imgItem.tagged = 0;
        }
      } catch(e) {
        this.$message.error("收藏失败");
      }
    },
    largeImg(path) {
      this.largeImgage = Util.IMGPATHROOT + path;
      this.showLargeImage = true;
      this.$emit("message",{src: this.largeImgage,status: this.showLargeImage,type:'large'});
    },
  },
  components: {
    DetailedResults,
    CompareImage,
    Lookimage,
  },
};
</script>
<style>
  #pageCon__14 .scrollCon .el-input__inner{
    /*background-color: inherit !important;*/
    color: rgba(0,0,0,0) !important;
  }
</style>
<style lang="less" scoped>
.pageCon,.header,.leftText,.diagnoseItemCon,.baseInfoCon,.diagnoseHeader,.btns,.checkTypeCon,.checkHeader,.leftCheck
,.imgsCon,.imgBackCon,.scrollCon,.checksCon{
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.timeline-row{
  display: flex;
  flex-direction: row;
}
/*::-webkit-scrollbar{*/
    /*width: 5px;*/
    /*height: 100%;*/
/*}*/
/*::-webkit-scrollbar-track-piece{*/
    /*background: #fff;*/
    /*-webkit-border-radius: 6px;*/
/*}*/
/*::-webkit-scrollbar-thumb:vertical{*/
    /*background-color: #61a2bf;*/
    /*-webkit-border-radius: 6px;*/
/*}*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.pageCon{
  position: fixed;
  background: #ebebeb;
  left: 0;
  top: 5%;
  width: 75%;
  height: 85%;
  margin-left: 12%;
  text-align: center;
  padding: 5px 10px;
  border-radius: 10px;
  z-index: 1;
  .header{
    margin-bottom: 5px;
    flex-direction: row;
    border-bottom: 1px solid #61a2bf;
    color: #61a2bf;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px;
    .leftText{
      margin-left: 20px;
      flex-direction: row;
      align-items: center;
    }

  }
  .scrollCon{
    overflow-y: auto;
    height: calc(~"100% - 65px");
    .timeline-row{
      margin-bottom: 20px;
      .diagnoseItemCon{
        margin-bottom: 0;
        flex: 1;
      }
      .timeline-side{
        display: flex;
        flex-direction: column;
        width: 140px;
        flex-shrink: 0;
        padding-top: 10px;
        .timeline-dot-row{
          display: flex;
          flex-direction: row;
          align-items: center;
          .timeline-dot{
            width: 12px;
            height: 12px;
            border-radius: 50%;
            flex-shrink: 0;
            margin-right: 6px;
          }
          .timeline-date{
            color: #333;
            font-weight: 600;
            text-align: left;
          }
        }
        .dot-影像{
          background: #61a2bf;
        }
        .dot-住院{
          background: rgb(146,82,17);
        }
        .dot-手术{
          background: rgb(165, 191, 108);
        }
        .dot-美容{
          background: rgb(146, 27, 81);
        }
        .timeline-type-text{
          margin-top: 4px;
          text-align: left;
          padding-left: 18px;
        }
        .type-影像{
          color: #61a2bf;
        }
        .type-住院{
          color: rgb(146,82,17);
        }
        .type-手术{
          color: rgb(165, 191, 108);
        }
        .type-美容{
          color: rgb(146, 27, 81);
        }
        .timeline-active-badge{
          display: inline-block;
          background: #4da2be;
          color: #fff;
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 10px;
          margin-top: 4px;
          padding-left: 18px;
        }
        .timeline-line{
          width: 2px;
          flex-grow: 1;
          background: #ccc;
          margin-top: 8px;
        }
      }
      .timeline-break .timeline-line{
        display: none;
      }
    }
    .diagnoseItemCon{
      margin-bottom: 20px;
      .diagnoseHeader{
        align-items: flex-start;
        background: #61a2bf;
        color: #fff;
        padding: 6px 10px;
        box-sizing: border-box;
        .baseInfoCon{
          width: 100%;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .btns{
            flex-direction: row;
            justify-content: flex-start;
            .btn{
              cursor: pointer;
              justify-self: flex-end;
              height: 20px;
              line-height: 20px;
             // padding: 3px 12px;
              padding: 0px;
              background: #fff;
              color: #61a2bf;
              font-size: 12px;
              margin-right: 10px;
              border-radius: 5px;
            }
            .btn:hover{
              background: #f2f2f2;
            }
          }
        }
        .baseInfoCon-1{
          display: flex;
          align-items: center;
          .con{
            display: flex;
            justify-content: flex-start;
            width: 200px;
            margin-right: 20px;
          }
        }
        .medical-record-section{
          display: flex;
          flex-direction: row;
          .medical-record-content{
            flex: 1;
            .mr-title{
              font-weight: 600;
              // font-size: 13px;
              color: #fff;
              margin: 6px 0px;
            }
            .mr-field{
              // font-size: 12px;
              color: #fff;
              margin: 6px 0px;
              text-align: left;
              .mr-label{
                color: #fff;
              }
            }
          }
          .medical-record-btn{
            display: flex;
            align-items: center;
            .btn{
              cursor: pointer;
              background: #fff;
              color: #61a2bf;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
              border-radius: 5px;
              white-space: nowrap;
              margin-right: 10px;
            }
            .btn:hover{
              background: #f2f2f2;
            }
          }
        }
      }
      .checksCon{
        .checkTypeCon{
          background: #eff3f7;
          padding: 2px 15px;
          box-shadow: 3px 5px 5px grey;
          box-sizing: border-box;
          .checkHeader{
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            color: #61a2bf;
            .leftCheck{
              align-items: flex-start;
                .span-text{
                    /*overflow:hidden;*/
                    /*text-overflow:ellipsis;*/
                    /*white-space:nowrap*/
                }
            }
            .rightbtn{
              .btn_color{
                background: #61a2bf;
                color: #fff;
                padding: 6px 20px;
                border-radius: 5px;
                cursor: pointer;
              }
              .btn_color:hover{
                background: #61b2bf;
              }
            }
          }
          .imgsCon{
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            .imgBackCon{
              width: 130px;
              height: 120px;
              position: relative;
              padding: 5px;
              margin-right: 5px;
              margin-bottom: 10px;
              flex-direction: column;
              align-items: center;
              justify-content: space-between;
              background-color: #fff;
              cursor: pointer;
              .img-box{
                width: 130px;
                height: 100px;
                margin-bottom: 2px;
                overflow: hidden;
              }
              .diseasePosition{
                font-size: 12px;
                color: #000;
                .wd-btn {
                  display: inline-block;
                  padding: 0 4px;
                  font-size: 11px;
                  line-height: 16px;
                  background-color: #ccc;
                  cursor: pointer;
                  user-select: none;
                  vertical-align: middle;
                  border-radius: 2px;
                  margin-left: 4px;
                }
                .wd-btn-active {
                  background-color: #9b59b6;
                  color: #fff;
                }
                .wd-btn:hover {
                  opacity: 0.85;
                }
              }
                .diseasePosition2{
                  width:120%;
                  transform: scale(0.8);

                }
              .loveImg{
                cursor: pointer;
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                top: 8px;
                right: 8px;
                padding: 2px;
                opacity: 0.5;
                background: #fff;
              }
              .largeImg{
                cursor: pointer;
                position: absolute;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                top: 8px;
                right: 35px;
                padding: 2px;
                opacity: 0.5;
                background: #fff;
              }
            }
          }
        }
      }
      .checksCon1 {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 15px;
        background-color: rgb(235, 235, 235);
  
        .image-item {
          width: 130px;
          height: 130px;
          padding: 5px;
          background-color: #fff;
          margin-right: 5px;
          margin-bottom: 10px;
    
          .image {
            width: 130px;
            height: 110px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            cursor: pointer;
          }
    
          .title {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
.cosmetology-list-wrap{
   display: flex;
   flex-direction: column;
   width: 100%;
   .cosmetology-row{
     display: flex;
     flex-direction: row;
     align-items: flex-start;
     color: #fff;
     //  font-size: 12px;
     margin: 6px 0px;
     .cr-item{
       text-align: left;
       min-width: 220px;
       padding-right: 16px;
       .label{
         padding-right: 2px;
       }
     }
     .cr-num{
       min-width: 20px !important;
       font-weight: 600;
     }
   }
 }

.el-dialog--center .el-dialog__body{
    padding:0 !important;
}
.el-dialog__body{
    padding:0 !important;
}

</style>

